(() => {
  const storageKey = "gbof-complete-pizza-night-v1";
  const allowedMatches = new Set(["easy", "romana", "original", "sourdough"]);

  function getStoredMatch() {
    try {
      const saved = window.localStorage.getItem(storageKey);
      return allowedMatches.has(saved || "") ? saved : "";
    } catch {
      return "";
    }
  }

  function storeMatch(matchKey) {
    try { window.localStorage.setItem(storageKey, matchKey); } catch { /* Local storage is optional. */ }
  }

  function updateButton(button, pending) {
    button.disabled = pending;
    button.setAttribute("aria-busy", String(pending));
    button.textContent = pending ? "Adding your list…" : "Add this list to cart";
  }

  function initialise(root) {
    const doughName = root.querySelector("[data-gbof-complete-dough-name]");
    const boxLink = root.querySelector("[data-gbof-complete-box-link]");
    const addButton = root.querySelector("[data-gbof-complete-add]");
    const message = root.querySelector("[data-gbof-complete-status]");
    const items = [...root.querySelectorAll("[data-gbof-complete-item]")];
    if (!doughName || !boxLink || !addButton || !message || items.length < 2) return null;

    const choices = {
      easy: {
        name: "12 Easy Stretch dough balls",
        doughId: root.dataset.easyVariantId,
        boxUrl: root.dataset.easyBoxUrl,
      },
      romana: {
        name: "10 Romana Tonda dough balls",
        doughId: root.dataset.romanaVariantId,
        boxUrl: root.dataset.romanaBoxUrl,
      },
      original: {
        name: "12 Original Neapolitan dough balls",
        doughId: root.dataset.originalVariantId,
        boxUrl: root.dataset.originalBoxUrl,
      },
      sourdough: {
        name: "12 All Natural Sourdough dough balls",
        doughId: root.dataset.sourdoughVariantId,
        boxUrl: root.dataset.sourdoughBoxUrl,
      },
    };

    let selectedMatch = "";
    const setMatch = (matchKey) => {
      const selection = choices[matchKey];
      if (!selection?.doughId || !selection.boxUrl) return;
      selectedMatch = matchKey;
      storeMatch(matchKey);
      doughName.textContent = selection.name;
      doughName.dataset.gbofCompleteVariantId = selection.doughId;
      boxLink.href = selection.boxUrl;
      boxLink.removeAttribute("aria-disabled");
      addButton.disabled = false;
      message.textContent = "Saved on this device. Edit the extras, then add your list when you are ready.";
    };

    addButton.addEventListener("click", async () => {
      const selection = choices[selectedMatch];
      const doughId = selection?.doughId || doughName.dataset.gbofCompleteVariantId;
      if (!doughId || !/^\d+$/.test(doughId)) {
        message.textContent = "Choose your dough above before adding a pizza-night list.";
        return;
      }

      const chosenItems = [{ id: Number(doughId), quantity: 1 }];
      for (const item of items) {
        const input = item.matches("input") ? item : item.querySelector("input");
        const variantId = item.dataset.gbofCompleteItem || input?.dataset.gbofCompleteItem;
        if (!input?.checked || !variantId || !/^\d+$/.test(variantId)) continue;
        chosenItems.push({ id: Number(variantId), quantity: 1 });
      }

      updateButton(addButton, true);
      message.textContent = "Adding your pizza-night list to the cart…";
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Accept": "application/json", "Content-Type": "application/json" },
          body: JSON.stringify({ items: chosenItems }),
        });
        if (!response.ok) throw new Error(`Cart request returned ${response.status}`);
        window.location.assign("/cart");
      } catch {
        updateButton(addButton, false);
        message.textContent = "We could not add the list just now. Please try again, or add each item from its product page.";
      }
    });

    return { setMatch };
  }

  const savedList = document.querySelector("[data-gbof-complete-pizza-night]");
  const controller = savedList ? initialise(savedList) : null;
  if (!controller) return;

  const storedMatch = getStoredMatch();
  if (storedMatch) controller.setMatch(storedMatch);
  document.addEventListener("gbof:dough-match", (event) => {
    const matchKey = event instanceof CustomEvent ? event.detail?.matchKey : "";
    if (allowedMatches.has(matchKey)) controller.setMatch(matchKey);
  });
})();
